import styled from 'styled-components';

export const CartItemButton = styled.button`
  font-family: ${Styles.fontFamily.body};
  font-size: 0.875rem;
  color: ${Styles.color.grey.one};
  text-decoration: underline;
  background-color: ${Styles.color.white};
  border: 0;
  padding: 0.75rem;
  margin-left: -0.75rem;
  cursor: pointer;

  &[disabled] {
    color: ${Styles.color.grey.four};
    cursor: not-allowed;
  }
`;
